import React, { Dispatch } from "react";
import { Switch, Redirect, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { User } from "oidc-client";
import { appPaths, IAppState, ApiRequest, PageTitleSetter, appPageTitles } from "../../Common";
import { ProtectedRoute } from "../../Auth";
import SubmitFeedbackContainer from "./FeedbackForm/SubmitFeedbackContainer";
import ViewFeedbackContainer from "./FeedbackDetails/ViewFeedbackContainer";
import EditFeedbackContainer from "./FeedbackEdit/EditFeedbackContainer";
import DeleteFeedbackContainer from "./DeleteFeedback/DeleteFeedbackContainer";
import { setPath, setBreadcrumbs } from "../../Startup/Actions/StartupActions";
import { BreadcrumbData, breadcrumbService } from "../../Layout";
import { breadcrumbsMap } from "../Constants/breadcrumbsMap";
import { endpoints } from "../Constants/endpoints";
import ResponseHandler from "../../App/ResponseHandler";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import { Feedback } from "..";

type StateProps = {
  path?: string;
  user?: User;
};

type DispatchProps = {
  setPath: (location: string) => void;
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => void;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  path: state.app.path,
  user: state.oidc.user
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  setPath: (location: string) => dispatch(setPath(location)),
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => dispatch(setBreadcrumbs(breadcrumbs))
});

class FeedbackRoutes extends React.Component<RouteComponentProps & StateProps & DispatchProps> {
  resolveVariable = async (key: string, variables: Map<string, string>) => {
    switch (key) {
      case ":code":
        return this.getFeedbackName(variables.get(key));
      default:
        return key;
    }
  };

  getFeedbackName = async (code?: string) => {
    let title;

    if (code && this.props.user) {
      await ApiRequest.fromPath(endpoints.feedback.getTitle(code))
        .withAuthHeader()
        .get()
        .then(async response => {
          await ResponseHandler.handle(response, (result: ResponseResult<Feedback>) => {
            title = result.payload;
          });
        });
    }

    return title;
  };

  setBreadcrumbs = () => {
    if (this.props.path !== this.props.location.pathname) {
      // this.props.setPath(this.props.location.pathname);

      this.props.setBreadcrumbs(
        breadcrumbService.createBreadcrumbs(
          this.props.location.pathname,
          breadcrumbsMap,
          this.resolveVariable
        )
      );
    }
  };

  render() {
    this.setBreadcrumbs();

    return (
      <>
        <PageTitleSetter title={appPageTitles.general} />
        <Switch>
          <ProtectedRoute
            exact
            path={appPaths.feedback.submitFeedback}
            component={SubmitFeedbackContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.feedback.editFeedback}
            component={EditFeedbackContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.feedback.deleteFeedback}
            component={DeleteFeedbackContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.feedback.viewFeedback}
            component={ViewFeedbackContainer}
          />
          <Redirect to={appPaths.notFound} />
        </Switch>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackRoutes);
